<template>
  <form>
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Enquiry Form</h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <form-group
              label="Contact Name"
              input-type="text"
              :validator-object="$v.form.name"
            ></form-group>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <form-group
              label="Contact Phone No."
              input-type="text"
              :validator-object="$v.form.mobile"
            ></form-group>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <form-group
              label="Email Address"
              input-type="email"
              :validator-object="$v.form.email"
            ></form-group>
          </div>
          <div class="md-layout-item">
            <form-group label="Enquiry" :validator-object="$v.form.msg">
              <template v-slot:input>
                <md-textarea
                  v-model.trim="$v.form.msg.$model"
                  style="height: 12rem"
                />
              </template>
            </form-group>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-right">
            <md-button
              class="md-raised md-success"
              :disabled="loading"
              @click="submit"
              >Send Enquiry</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { email, required } from "vuelidate/lib/validators";
import FormGroup from "@/components/Forms/FormGroup";
import ApiService from "@/services/api";
import { toastLaravelErrors } from "@/mixins";

export default {
  name: "EnquiryForm",
  components: {
    FormGroup
  },
  mixins: [toastLaravelErrors],
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        mobile: "",
        msg: ""
      },
      loading: false
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      mobile: {
        required
      },
      email: {
        required,
        email
      },
      msg: {
        required
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.authUser;
    }
  },
  mounted() {
    this.form.name = this.user.first_name + " " + this.user.last_name;
    this.form.email = this.user.email;
    this.form.mobile = this.user.mobile_number;
  },
  methods: {
    submit() {
      if (!this.validate()) return;

      this.loading = true;

      ApiService.enquiry
        .sendEnquiry(this.form)
        .then(() => {
          this.$toast.success("Enquiry submitted successfully.");
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.toastLaravelErrors(error);
          } else if (error.response.status === 409) {
            this.$toast.error("The given email is already in use.");
          } else {
            this.$toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    }
  }
};
</script>
<style></style>
